import styled from 'styled-components';

import Menu from '@mindtickle/menu';
import { bgTokens, textTokens } from '@mindtickle/styles/lib';

export const StyledMenu = styled(Menu)`
  padding: 12px 8px;

  .mtdls-menu {
    display: flex;
    flex-direction: column;
  }
`;

export const StyledHeaderMenuItemGroup = styled(Menu.ItemGroup)`
  overflow: hidden;
  min-width: 0;
  padding: 6px 16px;
  border-radius: 4px;

  .mtdls-menu-item-group-title {
    display: none;
  }

  &:not(:last-child) {
    margin-bottom: 4px;
  }

  &:hover {
    background-color: ${bgTokens.COLOR_BG_ACCENT};

    .help-menu-item {
      color: ${textTokens.COLOR_TEXT_INVERSE};
    }
  }
`;
